import { FaEyeSlash, FaImage, FaUser, FaFile, FaUpload, FaSpinner, FaTrash, FaCalendar, FaFileAlt, FaExternalLinkAlt, FaDownload, FaRegCalendarAlt, FaBarcode, FaReceipt, FaStore, FaMoneyBillWave, FaSave } from "react-icons/fa"
import DinamicBoxButton from "../ui/components/DinamicBoxButton"
import EditButton from "../ui/components/EditButton"
import IdButton from "../ui/components/IdButton"
import CopyToClipBoard from "../../utils/CopyToClipBoard"
import { useState } from "react"
import Modal from "../ui/Modal"
import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { toast } from "react-toastify"
import InputFormValue from "../ui/components/InputFormValue"
import DinamicButton from "../ui/components/DinamicButton"
import { CircularProgress } from "@mui/material"

const getValueFromPath = (object, path) => {
  if (!object || !path) return undefined
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), object)
}

const bankAccounts = {
  BCP: {
    "Eduardo - Cta. 19195069993093 - CCI 00219119506999309354": "BCP Edu",
    "Yessica - Cta. 19102800857047 - CCI 00219110280085704755": "BCP Yess",
    "Soluciones Digitales BTL 360 - Cta. 1927226709058 - CCI 00219200722670905836": "BCP BTL",
  },
  Scotiabank: {
    "Yessica - Cta. 7060804239 - CCI 00931920706080423957": "Scotiabank Yess",
  },
  Interbank: {
    "MC - Cta. 2003004305580 - CCI 00320000300430558032": "Interbank MC",
  },
};

const opcionesTipoComprobante = [
  { label: "No definido", value: "No definido" },
  { label: "Boleta", value: "Boleta" },
  { label: "Factura", value: "Factura" },
  { label: "RH", value: "RH" },
  { label: "Proforma", value: "Proforma" },
  { label: "N/C", value: "N/C" },
  { label: "N/D", value: "N/D" },
  { label: "Tickets", value: "Tickets" },
  { label: "POS", value: "POS" },
]

const opcionesTipoVenta = [
  { label: "No definido", value: "No definido" },
  { label: "Venta nueva", value: "Venta nueva" },
  { label: "Renovacion", value: "Renovacion" },
  { label: "Hosting", value: "Hosting" },
  { label: "Dominio", value: "Dominio" },
  { label: "Otros servicios", value: "Otros servicios" },
  { label: "Asesoria", value: "Asesoria" },
  { label: "Soporte web", value: "Soporte web" },
  { label: "Visitas", value: "Visitas" },
]

// Combined bank+account options
const bankAccountOptions = Object.entries(bankAccounts).flatMap(([bank, accounts]) =>
  Object.entries(accounts).map(([accountString, alias]) => ({
    label: alias,
    value: `${bank}|||${accountString}`,
  }))
)

const ItemRowRegistroVentas = ({item, headers, headersTableActive, refetch}) => {

  const [openImagesModal, setOpenImagesModal] = useState(false)
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [uploadingFile, setUploadingFile] = useState(false)
  const [documents, setDocuments] = useState(item?.cotizacion?.docsVenta || []) 

  const [editForm, setEditForm] = useState({
    fechaPago: item?.fechaPago ? String(item.fechaPago).slice(0,10) : "",
    fechaPagoReal: item?.fechaPagoReal ? String(item.fechaPagoReal).slice(0,10) : "",
    numeroComprobante: item?.numeroComprobante || "",
    tipoComprobante: item?.cotizacion?.tipoComprobante || "No definido",
    tipoVenta: item?.cotizacion?.tipoVenta || "No definido",
    estadoPago: item?.pagado ? "Pagado" : "Pendiente",
    entidadPago: item?.banco && item?.cuenta ? `${item.banco}|||${item.cuenta}` : "",
    banco: item?.banco || "",
    cuenta: item?.cuenta || "",
  })

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank')
  }
  
  const [uploadingStatus, setUploadingStatus] = useState(false)

  const handleSaveEdit = async () => {
    try {
      setUploadingStatus(true)
      // 1) Actualizar el pago (pagosCotizaciones): fechaPago, fechaPagoReal, numeroComprobante, banco, cuenta
      const pagoPayload = {
        fechaPagoReal: editForm.fechaPagoReal ? new Date(editForm.fechaPagoReal).toISOString() : undefined,
        fechaPago: editForm.fechaPago ? new Date(editForm.fechaPago).toISOString() : undefined,
        numeroComprobante: editForm.numeroComprobante || "",
        banco: editForm.banco || "",
        cuenta: editForm.cuenta || "",
      }
      await axios.put(`${BACKEND}/api/pagosCotizaciones/${item?.id}`, pagoPayload, { withCredentials: true })

      // 2) Actualizar la cotización: tipoComprobante, tipoVenta
      const cotizacionPayload = {
        tipoComprobante: editForm.tipoComprobante || undefined,
        tipoVenta: editForm.tipoVenta || undefined,
      }

      await axios.put(`${BACKEND}/api/cotizaciones/${item?.cotizacion?.id}`, cotizacionPayload, { withCredentials: true })

      toast.success('Registro de venta actualizado')
      setOpenEditModal(false)
      if (typeof refetch === 'function') refetch()
    } catch (error) {
      console.log(error)
      toast.error('Error al actualizar el registro de venta')
    } finally {
      setUploadingStatus(false)
    }
  }

  const uploadFile = async ({ file }) => {
    try {
      setUploadingFile(true)

      const existingIds = (documents || []).map((d) => d.id)

      const formData = new FormData()
      formData.append('file', file)

      const responseFile = await axios.post(`${BACKEND}/api/documentosCotizaciones`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      const createdDoc = responseFile?.data?.doc
      const createdId = createdDoc?.id

      await axios.put(`${BACKEND}/api/cotizaciones/${item?.cotizacion?.id}`, {
        docsVenta: [...existingIds, createdId]
      }, { withCredentials: true })

      setDocuments((prev) => [...prev, createdDoc])
      toast.success('Documento subido exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo documento')
    } finally {
      setUploadingFile(false)
    }
  }

  const deleteFile = async ({ id }) => {
    try {
      const existingIds = (documents || []).map((d) => d.id)
      const updatedIds = existingIds.filter((docId) => docId !== id)

      await axios.delete(`${BACKEND}/api/documentosCotizaciones/${id}`, { withCredentials: true })

      await axios.put(`${BACKEND}/api/cotizaciones/${item?.cotizacion?.id}`, {
        docsVenta: updatedIds
      }, { withCredentials: true })

      setDocuments((prev) => prev.filter((d) => d.id !== id))
      toast.success('Documento eliminado exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando documento')
    }
  }

  return (
    <>
      <Modal // Imágenes
        activeModal={openImagesModal}
        onClose={() => { setOpenImagesModal(false) }}
        title="Imágenes del ítem"
        className="w-full max-w-xl"
        centered
      >
        <div className="flex items-center justify-center">
          {item.imagen ? 
            item.imagen.mimeType === "application/pdf" ? (
              <embed
                src={item.imagen.url}
                type="application/pdf"
                onClick={() => openFileInNewTab(item.imagen.url)}
                className="max-w-full border border-gray-300 rounded-lg shadow-md h-[70vh] rounded"
              />
            ) : (
              <img
                src={item.imagen.url}
                alt={`Imagen del pago`}
                onClick={() => openFileInNewTab(item.imagen.url)}
                className="max-w-full border border-gray-300 rounded-lg shadow-md max-h-[75vh] object-contain rounded"
              />
            ) : (
              <div className="text-xs text-center text-gray-500 py-8 w-full">
                No hay imágenes disponibles
              </div>
            )
          }
        </div>
      </Modal>

      <Modal // Documentos
        activeModal={openDocumentsModal}
        onClose={() => { setOpenDocumentsModal(false) }}
        title="Documentos de la venta"
        className="max-w-4xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
            <input
              type="file"
              id="docs-upload"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
              multiple
              className="hidden"
              disabled={uploadingFile}
              onChange={(e) => {
                const files = Array.from(e.target.files || [])
                files.forEach((file) => uploadFile({ file }))
              }}
            />
            <label htmlFor="docs-upload" className={`cursor-pointer ${uploadingFile ? 'opacity-50' : ''}`}>
              {uploadingFile ? (
                <FaSpinner className="mx-auto text-sm text-gray-400 mb-2 animate-spin" />
              ) : (
                <FaUpload className="mx-auto text-sm text-gray-400 mb-2" />
              )}
              <p className="text-gray-600 text-sm">
                {uploadingFile ? 'Subiendo...' : 'Haz clic para subir documentos'}
              </p>
              <p className="text-xs mt-2 text-gray-400">PDF, DOC, XLS, JPG, PNG hasta 10MB</p>
            </label>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {documents && documents.length > 0 ? (
              documents.map((doc, index) => (
                <div key={doc.id || index} className="border rounded-lg p-3 bg-white flex items-center gap-3">
                  <FaFileAlt className="text-gray-400 text-sm" />
                  <span className="text-xs text-gray-700 flex-1 truncate">
                    {doc.filename || doc.fileName || `Documento ${index + 1}`}
                  </span>
                  <button
                    onClick={() => openFileInNewTab(doc.url)}
                    className="text-blue-600 hover:text-blue-800 p-1"
                    title="Ver documento"
                  >
                    <FaExternalLinkAlt className="text-xs" />
                  </button>
                  <button
                    onClick={() => {
                      const link = document.createElement('a')
                      link.href = doc.url
                      link.download = doc.filename || doc.fileName || 'documento'
                      link.click()
                    }}
                    className="text-green-600 hover:text-green-800 p-1"
                    title="Descargar documento"
                  >
                    <FaDownload className="text-xs" />
                  </button>
                  <button
                    onClick={() => deleteFile({ id: doc.id })}
                    className="text-red-500 hover:text-red-700 p-1"
                    title="Eliminar documento"
                  >
                    <FaTrash className="text-sm" />
                  </button>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500 py-8 text-xs">
                No hay documentos disponibles
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal // Editar registro de venta
        activeModal={openEditModal}
        onClose={() => { setOpenEditModal(false) }}
        title="Editar registro de venta"
        className="max-w-4xl"
        centered
      >
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputFormValue
              title="Fecha de emisión"
              value={editForm.fechaPago}
              setValue={(value) => setEditForm(prev => ({ ...prev, fechaPago: value }))}
              icon={<FaCalendar />}
              type="date"
            />
            <InputFormValue
              title="Fecha de venta"
              value={editForm.fechaPagoReal}
              setValue={(value) => setEditForm(prev => ({ ...prev, fechaPagoReal: value }))}
              icon={<FaRegCalendarAlt />}
              type="date"
            />
            <InputFormValue
              title="Tipo de comprobante"
              value={editForm.tipoComprobante}
              setValue={(value) => setEditForm(prev => ({ ...prev, tipoComprobante: value }))}
              icon={<FaReceipt />}
              type="select"
              options={opcionesTipoComprobante}
            />
            <InputFormValue
              title="N° de comprobante"
              value={editForm.numeroComprobante}
              placeholder="Número de comprobante"
              setValue={(value) => setEditForm(prev => ({ ...prev, numeroComprobante: value }))}
              icon={<FaBarcode />}
              type="text"
            />
            <InputFormValue
              title="Tipo de venta"
              value={editForm.tipoVenta}
              setValue={(value) => setEditForm(prev => ({ ...prev, tipoVenta: value }))}
              icon={<FaStore />}
              type="select"
              options={opcionesTipoVenta}
            />
            <InputFormValue
              title="Entidad de pago"
              value={editForm.entidadPago}
              setValue={(value) => {
                const [bank, account] = String(value || '').split('|||')
                setEditForm(prev => ({ ...prev, entidadPago: value, banco: bank || '', cuenta: account || '' }))
              }}
              icon={<FaMoneyBillWave />}
              type="select"
              options={bankAccountOptions}
            />

          </div>
          {/* Botones de acción */}
          <div className="flex w-full justify-center items-center gap-2 mt-4">
            <DinamicButton
              action={() => { setOpenEditModal(false) }}
              content="Cancelar"
              backgroundColor="#6b7280"
              hoverBackgroundColor="#4b5563"
              width="50%"
            />
            <DinamicButton
              action={handleSaveEdit}
              disabled={uploadingStatus}
              content="Actualizar registro"
              icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <FaSave size={14} />}
              width="50%"
            />
          </div>
        </div>
      </Modal>
 
      <tr key={item.id} className="text-xs py-3 w-full text-gray-900 hover:bg-gray-100 transition-all duration-100">
        
        {headers.map((header, idx) => (
          headersTableActive.find((e) => e.id === header.id)?.show && (
            header.value === "actions" ? (
              <td key={`actions-${idx}`} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className="flex flex-row gap-2 justify-center">
                  <EditButton
                    content="Editar item"
                    action={() => setOpenEditModal(true)}
                  />
                </div>
              </td>
            ) : header.value === "imagenes" ? (
              <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className="flex flex-row gap-2 justify-center items-center">
                  {item.imagen ? (
                    <DinamicBoxButton
                      content="Ver imágen del pago"
                      icon={<FaImage/>}
                      action={() => setOpenImagesModal(true)}
                      backgroundColor="#3b82f6"
                      hoverBackgroundColor="#2563eb"
                      size="sm"
                    />
                  ) : (
                    <DinamicBoxButton
                      content="No hay imagen disponible"
                      icon={<FaEyeSlash/>}
                      action={() => setOpenImagesModal(true)}
                      color="gray"
                      size="sm"
                      disabled
                    />
                  )}
                </div>
              </td>
            ) : header.value === "documentos" ? (
              <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className="flex flex-row gap-2 justify-center items-center">
                  {(documents && documents.length > 0) ? (
                    <>
                      <DinamicBoxButton
                        content="Ver documentos"
                        icon={<FaFile/>}
                        action={() => setOpenDocumentsModal(true)}
                        backgroundColor="#3b82f6"
                        hoverBackgroundColor="#2563eb"
                        size="sm"
                      />
                      <span className="text-xs text-gray-500">
                        {documents.length}
                      </span>
                    </>
                  ) : (
                    <DinamicBoxButton
                      content="Sin documentos"
                      icon={<FaFile/>}
                      action={() => setOpenDocumentsModal(true)}
                      color="gray"
                      size="sm"
                    />
                  )}
                </div>
              </td> 
            ) : header.value === "cotizacion.id" ? (
              <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className="flex flex-row gap-2 justify-center items-center">
                  <IdButton
                    content={item.cotizacion.id}
                    action={() => CopyToClipBoard(item.cotizacion.id)}
                  />
                </div>
              </td>
            ) : header.value === "cuentaBancaria" ? (
              <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className="flex flex-row gap-2 justify-center items-center">
                 {bankAccounts[item?.banco?.trim()]?.[item?.cuenta?.trim()] ?? item?.cuenta ?? "-"}              
                </div>
              </td>
            ) : header.value === "pagado" ? (
              <td key={idx} scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                <div className={`flex flex-row gap-2 justify-center items-center ${item?.pagado ? "text-green-500" : "text-red-500"}`}>
                 {item?.pagado ? "Pagado" : "Pendiente"}              
                </div>
              </td>
            ) : (
              (() => {
                const rawValue = getValueFromPath(item, header.value)
                const value = header.formatter ? header.formatter(rawValue) : (rawValue ?? "-")
                return (
                  <td key={idx} scope="row" className={`px-4 py-1 border border-gray-300 truncate text-${header.align || "center"} z-10 ${value && value !== "-" ? `${header.customColor ? header.customColor[value] : "text-gray-900"}` : "text-gray-200"}`}>
                    {value}
                  </td>
                )
              })()
            )
          )
        ))}
      </tr>
    </>
  )
}

export default ItemRowRegistroVentas